<div class="p-3 box h-100 overflow-auto crm-scroll">
  <h1>{{ 'general' | translate }}</h1>

  <div class="bg-white rounded shadow p-4">
    <div class="setting-box">
      @if (settingsForm) {
        <div class="d-flex flex-column gap-2 text-black" [formGroup]="settingsForm">
          <div class="d-flex justify-content-between align-items-center setting-item">
            <label>{{ 'notifications' | translate }}:</label>
            <app-toggle [formControl]="settingsForm.controls.is_notification"></app-toggle>
          </div>
          <div class="d-flex justify-content-between align-items-center setting-item">
            <label>{{ 'notification_sound' | translate }}:</label>
            <app-toggle [formControl]="settingsForm.controls.is_notification_sound"></app-toggle>
          </div>
          <div class="d-flex justify-content-between align-items-center setting-item">
            <label>{{ 'mark_as_read' | translate }}:</label>
            <app-toggle [formControl]="settingsForm.controls.is_message_read"></app-toggle>
          </div>
          <div class="d-flex justify-content-between align-items-center setting-item">
            <label>{{ 'lazy_loading' | translate }}:</label>
            <app-toggle [formControl]="settingsForm.controls.is_lazy_loading"></app-toggle>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <label>{{ 'language' | translate }}:</label>
            <app-select
              labelType="float"
              optionLabel="name"
              optionValue="value"
              [options]="languages"
              [formControl]="settingsForm.controls.language"
            />
          </div>
        </div>
      }
      <div class="d-flex justify-content-end gap-2">
        <app-button [disabled]="isSave()" (onChangeClick)="saveChanges()">{{ 'save' | translate }} </app-button>
        <app-button [btnType]="'stroked'" (onChangeClick)="cancelChanges()">{{ 'cancel' | translate }} </app-button>
      </div>
    </div>
  </div>
</div>
